import { Injectable } from '@angular/core';

import { OfferScope } from '@core/offers-data';
import type { OfferItem } from '@core/offers-types';
import type { BulkAction, BulkItemBase } from '@recruitee/bulk-actions-legacy';
import type { BulkItemWrapped } from '@recruitee/views-types';
import { isBulkItemWrapped } from '@recruitee/views-types';

import { OffersBulkActionsController } from '../../offers-page/offers-bulk-actions.controller';

@Injectable()
export class ViewsOffersBulkActionsController extends OffersBulkActionsController {
  public getBulkActions(): BulkAction[] {
    const active = super.getBulkActions({ offersScope: OfferScope.Active });
    const selectedOffers = <OfferItem[]>this.getSelectedOffers();
    const hasAllOffersActive = selectedOffers.every(offer => offer.status !== 'archived');
    if (hasAllOffersActive) return active;

    const hasAllOffersArchived = selectedOffers.every(offer => offer.status === 'archived');
    const archived = super.getBulkActions({ offersScope: OfferScope.Archived });
    if (hasAllOffersArchived) return archived;

    return [
      ...active,
      ...archived.filter(action => !active.find(activeAction => activeAction.id === action.id)),
    ];
  }

  protected getSelectedOffers(): BulkItemBase[] {
    const items = <Array<BulkItemWrapped | BulkItemBase>>super.getSelectedOffers();
    const allItems = items.map(item => {
      if (isBulkItemWrapped in item) return item.record;

      return item;
    });
    return Object.values(Object.fromEntries(allItems.map(item => [item.id, item])));
  }
}
